import { ReactNode } from "react";
import {
  RefineThemedLayoutV2SiderProps,
  ThemedLayoutV2,
  ThemedSiderV2,
} from "@refinedev/mui";
import { Header } from "./Header";
import { useTranslation } from "@refinedev/core";
import { SyncrosaleThemedTitle } from "./SyncrosaleThemedTitle";
import { getRuntimeEnv } from "../../providers/getRuntimeEnv";

interface SyncrosaleLayoutProps {
  children: ReactNode;
}

export const SyncrosaleLayout = ({ children }: SyncrosaleLayoutProps) => {
  return (
    <ThemedLayoutV2 Header={Header} Title={SyncrosaleTitle} Sider={Sider}>
      {children}
    </ThemedLayoutV2>
  );
};

const SyncrosaleTitle = () => {
  const { translate } = useTranslation();
  const runtimeEnv = getRuntimeEnv();
  const isDevEnv = runtimeEnv === "dev";
  const logo = isDevEnv ? "/icons/logo-dev.svg" : "/icons/logo.svg";
  return (
    <SyncrosaleThemedTitle
      icon={logo}
      text={translate("documentTitle.default")}
    />
  );
};

// Removes logout button from sidebar
const Sider = (props: RefineThemedLayoutV2SiderProps) => {
  return <ThemedSiderV2 {...props} render={({ items }) => <>{items}</>} />;
};
